import { createElement } from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import ProtectedCustomerRoute from "../../Components/ProtectedCustomerRoute";
import MarketPage from "./MarketPage";
import MerchantForm from "./Merchant/MerchantForm";
import EmptyCart from "./Cart/EmptyCart";
import CartListView from "./Cart/CartListView";
import ShippingDetail from "./Cart/CartPayment/ShippingDetail";
import MarketplacePaymentVerification from "./Cart/PaymentVerification";
import OrderConfirmation from "./Cart/OrderConfirmation";
import ProductListingPage from "./components/ProductListingPage";
import SearchResultsPage from "./Search/SearchResultsPage";
import MerchantStorefrontPage from "./Store/MerchantStorefrontPage";
import AllProductDetail from "./AllProductDetail/productdeatils";
import UserProfile from "./MarketUser/UserProfile";
import Customerorder from "./MarketUser/customerorder";
import OrderDetail from "./MarketUser/OrderDetail";
import Customermsginbox from "./MarketUser/customermsginbox";
import Customersaveditem from "./MarketUser/customersaveditem";
import Accountmanagement from "./MarketUser/accountmanagement";
import Addressbook from "./MarketUser/addressbook";
import Recentview from "./MarketUser/recentview";
import Pendingreview from "./MarketUser/pendingreview";
import Returnpolicy from "../Return_Policy/returnpolicy";
import Trackyourorder from "../Tracking/trackyourorder";
import { MARKET, ACCOUNT, MARKETPLACE_LEGACY_REDIRECTS } from "./libs/marketplaceRoutes";

const LegacyPublicProductRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/market/product/${slug}`} replace />;
};

const LegacyOrderConfirmationRedirect = () => {
  const { orderId } = useParams();
  return <Navigate to={`/market/order-confirmation/${orderId}`} replace />;
};

const LegacyAccountOrderRedirect = () => {
  const { orderId } = useParams();
  return <Navigate to={`/account/orders/${orderId}`} replace />;
};

const protect = (element) => <ProtectedCustomerRoute>{element}</ProtectedCustomerRoute>;

/** Flat Route elements for use as direct children of <Routes>. */
export const marketplaceLegacyRedirectRoutes = [
  ...MARKETPLACE_LEGACY_REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} caseSensitive element={<Navigate to={to} replace />} />
  )),
  <Route key="legacy-product" path="/product/:slug" element={<LegacyPublicProductRedirect />} />,
  <Route key="legacy-order-confirmation" path="/order-confirmation/:orderId" element={<LegacyOrderConfirmationRedirect />} />,
  <Route key="legacy-customer-order" path="/customerorder/:orderId" element={<LegacyAccountOrderRedirect />} />,
];

/** Home route kept separate so it always registers before the / layout route. */
export const marketplaceHomeRoute = (
  <Route key="market-home" path={MARKET.HOME} element={<MarketPage />} />
);

/** Flat Route elements for use as direct children of <Routes>. */
export const marketplaceRoutes = [
  <Route key="market-sell" path={MARKET.SELL} element={<MerchantForm />} />,
  <Route key="market-cart" path={MARKET.CART} element={<CartListView />} />,
  <Route key="market-cart-empty" path={MARKET.CART_EMPTY} element={<EmptyCart />} />,
  <Route key="market-checkout" path={MARKET.CHECKOUT} element={<ShippingDetail />} />,
  <Route key="market-payment" path={MARKET.PAYMENT_VERIFICATION} element={<MarketplacePaymentVerification />} />,
  <Route key="market-order-confirmation" path={MARKET.ORDER_CONFIRMATION} element={<OrderConfirmation />} />,
  <Route key="market-product" path={MARKET.PRODUCT} element={<AllProductDetail />} />,
  <Route key="market-search" path={MARKET.SEARCH} element={<SearchResultsPage />} />,
  <Route key="market-store" path={MARKET.STORE} element={createElement(MerchantStorefrontPage)} />,
  <Route key="market-return-policy" path={MARKET.RETURN_POLICY} element={<Returnpolicy />} />,
  <Route key="market-track-order" path={MARKET.TRACK_ORDER} element={<Trackyourorder />} />,
  <Route key="cat-supermarket" path={MARKET.CATEGORY_SUPERMARKET} element={<ProductListingPage />} />,
  <Route key="cat-health-beauty" path={MARKET.CATEGORY_HEALTH_BEAUTY} element={<ProductListingPage />} />,
  <Route key="cat-home-office" path={MARKET.CATEGORY_HOME_OFFICE} element={<ProductListingPage />} />,
  <Route key="cat-appliances" path={MARKET.CATEGORY_APPLIANCES} element={<ProductListingPage />} />,
  <Route key="cat-phones-tablets" path={MARKET.CATEGORY_PHONES_TABLETS} element={<ProductListingPage />} />,
  <Route key="cat-computing" path={MARKET.CATEGORY_COMPUTING} element={<ProductListingPage />} />,
  <Route key="cat-electronics" path={MARKET.CATEGORY_ELECTRONICS} element={<ProductListingPage />} />,
  <Route key="cat-fashion" path={MARKET.CATEGORY_FASHION} element={<ProductListingPage />} />,
  <Route key="cat-baby-kids" path={MARKET.CATEGORY_BABY_KIDS} element={<ProductListingPage />} />,
  <Route key="cat-gaming" path={MARKET.CATEGORY_GAMING} element={<ProductListingPage />} />,
  <Route key="cat-sporting" path={MARKET.CATEGORY_SPORTING} element={<ProductListingPage />} />,
  <Route key="cat-grocery" path={MARKET.CATEGORY_GROCERY} element={<ProductListingPage />} />,
  <Route key="cat-kitchen" path={MARKET.CATEGORY_KITCHEN} element={<ProductListingPage />} />,
  <Route key="cat-building" path={MARKET.CATEGORY_BUILDING} element={<ProductListingPage />} />,
  <Route key="deals-today" path={MARKET.DEALS_TODAY} element={<ProductListingPage />} />,
  <Route key="deals-top-selling" path={MARKET.DEALS_TOP_SELLING} element={<ProductListingPage />} />,
  <Route key="deals-recommended" path={MARKET.DEALS_RECOMMENDED} element={<ProductListingPage />} />,
  <Route key="deals-trending" path={MARKET.DEALS_TRENDING} element={<ProductListingPage />} />,
  <Route key="account-home" path={ACCOUNT.HOME} element={protect(<UserProfile />)} />,
  <Route key="account-orders" path={ACCOUNT.ORDERS} element={protect(<Customerorder />)} />,
  <Route key="account-order-detail" path={ACCOUNT.ORDER_DETAIL} element={protect(<OrderDetail />)} />,
  <Route key="account-inbox" path={ACCOUNT.INBOX} element={protect(<Customermsginbox />)} />,
  <Route key="account-saved" path={ACCOUNT.SAVED} element={protect(<Customersaveditem />)} />,
  <Route key="account-settings" path={ACCOUNT.SETTINGS} element={protect(<Accountmanagement />)} />,
  <Route key="account-recent" path={ACCOUNT.RECENT} element={protect(<Recentview />)} />,
  <Route key="account-reviews" path={ACCOUNT.REVIEWS} element={protect(<Pendingreview />)} />,
  <Route key="account-addresses" path={ACCOUNT.ADDRESSES} element={protect(<Addressbook />)} />,
];
